/** @module CostScenario/_GroupCostsMixin */
define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		/**
		 * @override
		 * Refresh view if summary view changes
		 */
		postMixInProperties: function() {
			var viewSummary = this.viewParent ? this.viewParent.getChildView("Summary") : null;
			if (viewSummary) {
				this.connect(viewSummary, "postAction", function(ac) {
					if (ac && ac.bDataChanged) {
						this.refreshData();
					}
				});
			}

			this.inherited(arguments);
		}
	});
});